import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PartnerForm from './partnerForm';
import PageError from '../error/pageError';

export default class Partner extends React.Component {
    constructor() {
        super();
        this.state = {
            reloadKey: 0
        };

        this.reloadForm = this.reloadForm.bind(this);
    }

    reloadForm() {
        this.setState(({ reloadKey }) => ({ reloadKey: reloadKey + 1 }));
    }

    render() {
        const { path } = this.props;
        return (
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={basenameProps => (
                        <PartnerForm
                            key={this.state.reloadKey}
                            organization={this.props.organization}
                            event={this.props.event}
                            history={basenameProps.history}
                            reload={this.reloadForm}
                        />
                    )}
                />

                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organization.id}/E${this.props.event.id}`} />} />
            </Switch>
        );
    }
}

Partner.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
